module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/store_images/4_512341cb95a2cda66e9d59e0522677e9.png";